import { useDispatch, useSelector } from "react-redux";
import { clearTypeModal, clearTypeOfShowModalType, selectCurrentModalType, setTypeOfShowModalType } from "../../../features/modal/modalSlice";
import { resetNewProduct } from "../../../features/product/productSlice";
import { CloseIcon } from "../../../assets/icons/Svg";

export default function ProductModalHeader() {

    const dispatch = useDispatch()
    const typeModal = useSelector(selectCurrentModalType);
    
    const handleCloseModalProduct = () => {
        // ORIGINAL
        // dispatch(clearTypeModal());
        // // dispatch(clearSelectedProduct());
        // dispatch(resetNewProduct())
        // if (typeModal === 'newProduct') {
        //     dispatch(setTypeOfShowModalType('fbTypeModal'));
        // } else {
        //     dispatch(clearTypeOfShowModalType());
        // }
        
        dispatch(clearTypeModal());
        // dispatch(clearSelectedProduct());
        dispatch(resetNewProduct())
        dispatch(clearTypeOfShowModalType());
    }

    return (
        <div className="flex justify-between items-center py-1">
            <div className="items-start">
                <p className="text-sm items-start font-semibold leading-tight text-slate-900">
                    {typeModal === 'newProduct' && 'New Product'}
                    {typeModal === 'updateProduct' && 'Update Product'}
                </p>
            </div>
            <div className="flex justify-end items-center">
                <button
                    type="button"
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                    onClick={handleCloseModalProduct}
                >
                    <CloseIcon/>
                </button>
            </div>
        </div>
    )
}
